<template>
<el-card>
  <template v-slot:header>
    <div>
      <span class="mr-[40px]">区块链存证</span>
      <el-button @click="refresh()">刷新</el-button>
    </div>
  </template>

  <el-table ref="multipleTable" :data="blockTxs" border>
    <el-table-column fixed prop="index" label="序号" width="70">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.index }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="hash" label="哈希值" width="200">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis text-blue-300"><el-link type="primary" :href="`http://gxlscan.chain199.com/tradeHash?hash=${row.txHash}`" target="_blank"  style="font-size:12px">{{ row.txHashShow }}</el-link></div>
      </template>
    </el-table-column>
    <el-table-column prop="action" width="200" label="任务名称">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.action }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="action" label="重要程度">
      <template v-slot="{row}">
        <div :class="[row.level === '重要'?'text-[#F56C6C] font-bold':'']">{{ row.level }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="状态">
      <template v-slot="{row}">
        <div :class="[row.status === 0?'text-[#F56C6C] font-bold':'']">{{ row.statusShow }}</div>
      </template>
    </el-table-column>
    <el-table-column prop="operateTime" label="操作时间" width="170">
      <template v-slot="{row}">
        <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.timestamp }}</div>
      </template>
    </el-table-column>

    <el-table-column fixed="right" label="操作" width="148">
      <template v-slot="scope">
        <el-button @click="view(scope.row)" type="primary" size="mini">区块浏览器查看</el-button>
      </template>
    </el-table-column>
  </el-table>
</el-card>
</template>

<script>
import { 
  fetchBlockChain,
} 
from '@/api/api';
export default {
  name:"BlockChainPage",
  data() {
    return {
      blockTxs:[],
    }
  },

  mounted() { 
    // this.getBlockTxs();
  },

  methods: {
    getBlockTxs() {
      this.blockTxs = [];
      let that = this;
      fetchBlockChain().then(result => {
        if( result.data.code == 0) {
          let data = result.data.data;
          for (let i=0; i< data.total; i++) {
            let item = {}
            item.index = i+1;
            item.txHash = data.blockchains[i].tx_hash;
            item.txHashShow = that.getShowHash(item.txHash);
            item.kind = data.blockchains[i].kind;
            item.level = that.getLevel(item.kind);
            item.action = that.getAction(item.kind);
            item.status = data.blockchains[i].status;
            item.statusShow = that.getStatus(data.blockchains[i].status);
            item.content = data.blockchains[i].content;
            item.weight = data.blockchains[i].weight;
            item.timestamp = that.timestampToDateTime(data.blockchains[i].timestamp);
            that.blockTxs.push(item);
          }
          return;
        }
        if (result.data.code == 3) {
          localStorage.setItem("uid", "")
          localStorage.setItem("oid", "")
          localStorage.setItem('token', "");
          that.$router.push('/');
          return
        } 
        console.error("fetchBlockChain error code:", result.data.code, "message:", result.data.message)
      })
      .catch(err => {
        console.error(err)
      });
    },

    refresh(){  
      // this.getBlockTxs();
    },

    view(row) {
      const urlHash = "http://gxlscan.chain199.com/tradeHash?hash=" + row.txHash
      window.open(urlHash)
    },

    timestampToDateTime(timestamp) {
      const date = new Date(timestamp * 1000); 
      const year = date.getFullYear().toString().slice(-2);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    getAction(biz) {
      if(biz == 1) {
        return "登录系统";
      } else if(biz == 2) {
        return "增加部门";
      } 
      return "一般行为"
    },

    getLevel(biz) {
      switch(biz) {
        case 1:
          return "重要";
        case 2:
          return "一般";
        default:
          return "一般"
      } 
    },
    
    getStatus(status) {
      switch(status) {
        case 0:
          return "未上链";
        case 1:
          return "已上链";
        default:
          return "";
      } 
    },

    getShowHash(hash) {
      if(hash.length != 66) {
        return "";
      }
      return hash.substr(0,10) + "..." + hash.substr(58,8)
    },
  },
}
</script>